import { render, staticRenderFns } from "./CreateShippingAddressCard.vue?vue&type=template&id=dcfd66b0&scoped=true&lang=pug"
import script from "./CreateShippingAddressCard.vue?vue&type=script&lang=js"
export * from "./CreateShippingAddressCard.vue?vue&type=script&lang=js"
import style0 from "./CreateShippingAddressCard.vue?vue&type=style&index=0&id=dcfd66b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcfd66b0",
  null
  
)

export default component.exports